// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__135GD","label":"Category_label__2SyMc","content":"Category_content__1VldS","header":"Category_header__kMpOd","location":"Category_location__2plIY"};